var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedicineLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drug"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.028 89.964C43.416 99.576 27.756 99.576 18.036 89.964C8.31599 80.352 8.42399 64.692 18.036 54.972L36.504 36.504L71.496 71.496L53.028 89.964V89.964Z",
    fill: "#E15B64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M89.964 18.036C99.576 27.648 99.576 43.308 89.964 53.028L71.496 71.496L36.504 36.504L54.972 18.036C64.584 8.424 80.244 8.424 89.964 18.036V18.036Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.11,
    d: "M89.964 53.028L71.496 71.496L53.028 89.964C43.416 99.576 27.756 99.576 18.036 89.964L89.964 18.036C99.576 27.756 99.576 43.416 89.964 53.028Z",
    fill: "black"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineLoader);
export default __webpack_public_path__ + "static/media/medicine-loader.0e62a268c8ed3c674eca449693d1f07e.svg";
export { ForwardRef as ReactComponent };